import { Platform } from 'react-native'

import { APP_TYPE } from '../enums/appTypes'
import { getIsMobile } from './getIsMobile'

/**
 * Get appType, memoize it in a session cookie, return the memoized value if it exists, even on the server
 *
 * This function must be executed on the first page load because it uses document.referrer value
 */
export const getAppType = (): APP_TYPE => {
  const isAndroidTwa = Platform.OS === 'web' ? document?.referrer?.includes('android-app://org.hozana.app') : false
  const isIosPwa =
    Platform.OS === 'web' ? 'standalone' in window.navigator && window.navigator.standalone === true : false
  const isAndroidPwa = Platform.OS === 'web' ? window.matchMedia('(display-mode: standalone)')?.matches : false

  if (Platform.OS === 'ios' || window.navigator.userAgent.includes('HozanaAppli')) {
    return APP_TYPE.IOS_NATIVE
  } else if (Platform.OS === 'android') {
    return APP_TYPE.ANDROID_NATIVE
  } else if (isAndroidTwa) {
    return APP_TYPE.ANDROID_NATIVE
  } else if (isIosPwa) {
    return APP_TYPE.IOS_PWA
  } else if (isAndroidPwa) {
    return APP_TYPE.ANDROID_PWA
  } else if (window.navigator?.maxTouchPoints === 1) {
    return APP_TYPE.EMULATION
  } else if (getIsMobile()) {
    return APP_TYPE.BROWSER_MOBILE
  } else {
    return APP_TYPE.BROWSER_DESKTOP
  }
}
